import { HttpHandler, HttpInterceptor, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import 'rxjs/add/operator/timeout';
import { Observable } from 'rxjs/Observable';
import { catchError, switchMap, tap, timeout } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';
import { sortObject } from '../../helpers/root-page.helper';
import { Sha1Service } from '../../providers/secrypt';
import { AuthenticationBloc } from './../../bloc/authentication/authentication.bloc';
import { NestAuthProvider } from './nest-auth';
@Injectable()
export class TimeoutInterceptor implements HttpInterceptor {

  refreshTokenInProgress = false;
  tokenRefreshedSource = new Subject();
  tokenRefreshed$ = this.tokenRefreshedSource.asObservable();
  authenticationBloc: any;
  nestAuthProvider: any;
  sha1: any;

  constructor(
    private injector: Injector
  ) {

  }

  refreshToken(): Observable<any> {
    if (this.refreshTokenInProgress) {
      return new Observable(observer => {
        this.tokenRefreshed$.subscribe(() => {
          observer.next();
          observer.complete();
        });
      });
    } else {
      this.refreshTokenInProgress = true;
      return Observable.fromPromise(this.authenticationBloc.interceptorRefreshLogin()).pipe(
        tap(() => {
          this.refreshTokenInProgress = false;
          this.tokenRefreshedSource.next();
        }),
        catchError(() => {
          this.refreshTokenInProgress = false;
          return Observable.throw("Refresh token can't be used! Please re-login to renew and refresh the token.");
        }));
    }
  }

  handleResponseError(error, request?, next?) {
    if (error.status === 401) {
      return this.refreshToken().pipe(
        switchMap(() => {
          const authHeader = this.nestAuthProvider.getAccessToken();
          if (authHeader) {
            return next.handle(request.clone({
              setHeaders: {
                "Authorization": authHeader
              }
            }));
          }
          return next.handle(request);
        }),
        catchError(e => {
          return Observable.throw(e);
        }));
    }
    return Observable.throw(error);
  }

  // http.get('/your/url/here', { headers: new HttpHeaders({ timeout: `${20000}` }) });
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<any> {
    /** mark performance API*/
    performance.clearMarks();
    performance.mark('apiStart');

    this.authenticationBloc = this.injector.get(AuthenticationBloc);
    this.nestAuthProvider = this.injector.get(NestAuthProvider);
    this.sha1 = this.injector.get(Sha1Service);

    const timeoutValue = (req.method == 'DELETE') ? 60000 : Number(req.headers.get('timeout')) || 60000;
    req.headers.set('Allow-Control-Allow-Origin', '*');

    const recallRefreshToken = (req.method == 'DELETE') ? 'false' : req.headers.get('recallRefreshToken');

    try {
      if (req.body) {
        let data = req.body;
        if (typeof data === 'string') {
          try {
            data = JSON.parse(data);
          } catch (e) { }
        } else {
          const jsonString = JSON.stringify(data);
          try {
            data = JSON.parse(jsonString);
          } catch (e) { }
        }
        const salt = `5unf15hD4740N`; //(localStorage.getItem('$username')) ? `5unf15h${localStorage.getItem('$username')}D4740N` : `5unf15hD4740N`;
        const hash = this.sha1.getHash(JSON.stringify(sortObject(data)).trim(), salt, 7).toUpperCase();
        const isWebview = localStorage.getItem('webOpenFromWebview');
        if (isWebview) {
          req = req.clone({ headers: req.headers.set('X-GD-Params', hash).append("app", "gd8") });
        } else {
          req = req.clone({ headers: req.headers.set('X-GD-Params', hash) });
        }
      }
    } catch (error) {
      console.log(error);
    }

    if (localStorage.getItem('$account_code')) {
      req = req.clone({
        params: (req.params ? req.params : new HttpParams())
          .set('$account_code', localStorage.getItem('$account_code'))
      });
    }

    if (recallRefreshToken == 'true') {
      return next.handle(req).pipe(
        timeout(timeoutValue),
        catchError(error => { return this.handleResponseError(error, req, next) })
      );
    } else {
      return next.handle(req).pipe(timeout(timeoutValue));
    }
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/nest-timeout-interceptor.ts